/**
 * 一个单例的事件总线，用于一些跨组件通信的场景
 *
 * 要注意不应该滥用这个功能，否则代码的可读性会很低
 */
import mitt from 'mitt';
const eventBus = mitt();
export const EVENT = {
    updatePageContext: 'update-page-context',
    requestPageContext: 'request-page-context', // 主动去获取页面 Context
};
export default eventBus;
